module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[90]333.6ab5d75.woff2";